import React, { useEffect } from 'react';
import injectSheet from 'react-jss';

const styleSheet = {
  star1: {
    animation:
      'animationStar1Flow2 0.449s ease-out 0.45s forwards, animationStar1Flow3 0.449s ease-out 0.9s forwards',
  },
  star2: {
    animation:
      'animationStar2Flow1 0.449s ease-out 0s forwards, animationStar2Flow3 0.449s ease-out 0.9s forwards',
  },
  star3: {
    animation:
      'animationStar3Flow1 0.449s ease-out 0s forwards, animationStar3Flow2 0.449s ease-out 0.45s forwards',
  },
  '@keyframes animationStar1Flow2': {
    from: { opacity: 1 },
    to: { opacity: 0.2 },
  },
  '@keyframes animationStar1Flow3': {
    from: { opacity: 0.2 },
    to: { opacity: 1 },
  },
  '@keyframes animationStar2Flow1': {
    from: { opacity: 0.2 },
    to: { opacity: 1 },
  },
  '@keyframes animationStar2Flow3': {
    from: { opacity: 1 },
    to: { opacity: 0.2 },
  },
  '@keyframes animationStar3Flow1': {
    from: { opacity: 1 },
    to: { opacity: 0.2 },
  },
  '@keyframes animationStar3Flow2': {
    from: { opacity: 0.2 },
    to: { opacity: 1 },
  },
};

const SparkleAnimation = ({ classes }) => {
  useEffect(() => {
    const sourceIdNames = ['star1', 'star2', 'star3'];
    const candidateElement = document.getElementById('star2');

    const handleAnimationEnd = event => {
      if (event.animationName === 'animationStar2Flow3') {
        sourceIdNames.forEach(id => {
          const element = document.getElementById(id);
          if (element) {
            const animation = element.style.animation;
            element.style.animation = 'none';
            setTimeout(() => {
              element.style.animation = animation;
            }, 5);
          }
        });
      }
    };

    if (candidateElement) {
      candidateElement.addEventListener('animationend', handleAnimationEnd);
    }

    return () => {
      if (candidateElement) {
        candidateElement.removeEventListener(
          'animationend',
          handleAnimationEnd
        );
      }
    };
  }, [classes]);

  return (
    <div style={{ height: '17.5px', width: '17.75px' }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <g id="Sparkles_Grow1_0">
          <path
            id="star1"
            className={classes.star1}
            d="M9.16241 6.79823L7.30854 2.67591C7.20158 2.45894 6.98768 2.3143 6.77377 2.3143C6.55986 2.3143 6.34595 2.45894 6.27465 2.67591L4.38512 6.79823L0.320863 8.67859C0.106954 8.78707 0 9.00403 0 9.221C0 9.43796 0.106954 9.65492 0.320863 9.76341L4.38512 11.6438L6.27465 15.7661C6.34595 15.983 6.55986 16.1277 6.77377 16.1277C6.98768 16.1277 7.20158 15.983 7.30854 15.7661L9.16241 11.6438L13.2267 9.72725C13.4406 9.65492 13.5832 9.43796 13.5832 9.221C13.5832 9.00403 13.4406 8.78707 13.2267 8.67859L9.16241 6.79823Z"
            fill="#FBB654"
          />
          <path
            id="star2"
            opacity="0.2"
            className={classes.star2}
            d="M14.0705 2.95713L13.1673 3.3107C13.1039 3.32677 13.0564 3.40713 13.0564 3.47142C13.0564 3.55177 13.1039 3.63213 13.1673 3.6482L14.0705 3.9857L14.4032 4.90177C14.4191 4.96606 14.4983 5.01427 14.5775 5.01427C14.6409 5.01427 14.7201 4.96606 14.736 4.90177L15.0846 3.9857L15.9719 3.6482C16.0511 3.63213 16.0986 3.55177 16.0986 3.47142C16.0986 3.40713 16.0511 3.32677 15.9719 3.3107L15.0846 2.95713L14.736 2.05713C14.7201 1.97677 14.6409 1.92856 14.5775 1.92856C14.4983 1.92856 14.4191 1.97677 14.4032 2.05713L14.0705 2.95713Z"
            fill="#FBB654"
          />
          <path
            id="star3"
            className={classes.star3}
            d="M13.4366 13.3714L11.4045 14.167C11.2619 14.2031 11.1549 14.3839 11.1549 14.5286C11.1549 14.7094 11.2619 14.8902 11.4045 14.9263L13.4366 15.6857L14.1853 17.7469C14.2209 17.8915 14.3992 18 14.5774 18C14.72 18 14.8983 17.8915 14.934 17.7469L15.7183 15.6857L17.7148 14.9263C17.893 14.8902 18 14.7094 18 14.5286C18 14.3839 17.893 14.2031 17.7148 14.167L15.7183 13.3714L14.934 11.3464C14.8983 11.1656 14.72 11.0571 14.5774 11.0571C14.3992 11.0571 14.2209 11.1656 14.1853 11.3464L13.4366 13.3714Z"
            fill="#FBB654"
          />
        </g>
      </svg>
    </div>
  );
};

export default injectSheet(styleSheet)(SparkleAnimation);
